import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { createTheme } from '@mui/material';
import ezTheme from './ezTheme';
import { legacyColors } from '../ezColors';
var ezLegacyTheme = createTheme(ezTheme, {
  palette: {
    primary: {
      main: legacyColors.teal600,
      light: legacyColors.teal200,
      dark: legacyColors.teal700
    },
    secondary: {
      main: legacyColors.blue100,
      light: legacyColors.blue300,
      dark: legacyColors.blue950
    },
    error: {
      main: legacyColors.red100,
      light: legacyColors.red500,
      dark: legacyColors.red950
    },
    warning: {
      main: legacyColors.yellow100,
      light: legacyColors.yellow200,
      dark: legacyColors.yellow700
    },
    info: {
      main: legacyColors.blue700,
      light: legacyColors.blue500,
      dark: legacyColors.blue950
    },
    success: {
      main: legacyColors.green600,
      light: legacyColors.green500,
      dark: legacyColors.green700
    },
    text: {
      primary: legacyColors.black100,
      secondary: legacyColors.gray800,
      disabled: legacyColors.gray400
    },
    grey: {
      100: legacyColors.gray100,
      200: legacyColors.gray200,
      300: legacyColors.gray300,
      400: legacyColors.gray400,
      500: legacyColors.gray500,
      600: legacyColors.gray600,
      700: legacyColors.gray700,
      800: legacyColors.gray800
    },
    common: _objectSpread(_objectSpread({}, legacyColors), {}, {
      black: legacyColors.black100,
      white: legacyColors.white
    })
  }
});
export default ezLegacyTheme;